import { GameMetaAction, GameMetaType } from "../types/gameMeta";

export const setGameMeta = (gameMeta: GameMetaType) => {
  return {
    type: GameMetaAction.SET_GAME_META,
    gameMeta,
  };
};
